import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface BreadcrumbItem {
  label: string;
  link?: string | any[];
}

@Component({
    selector: 'ctv-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BreadcrumbsComponent {
  @Input() public items: BreadcrumbItem[] = [];
}
